import * as actionTypes from "../action-types";

const initialState = {
    categoryData: {},
    subCategoryData: [],
    videoBySubCategoryData: [],
    podcastBySubCategoryData: [],

    //! News
    breakingNewsData: [],
    newsCategoryData: [],
    newsByCategoryData: [],
    //! Live
    liveVideoData: [],

    //! Daily Darshan
    dailyDarshanData: [],
};

const sancharReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.SET_CATEGORY:
            return { ...state, categoryData: payload };

        case actionTypes.SET_SUB_CATEGORY:
            return { ...state, subCategoryData: payload };

        case actionTypes.SET_DATA_BY_SUB_CATEGORY:
            return { ...state, videoBySubCategoryData: payload };

        case actionTypes.SET_PODCAST_BY_SUB_CATEGORY:
            return { ...state, podcastBySubCategoryData: payload };

        //! News
        case actionTypes.SET_BREAKING_NEWS:
            return { ...state, breakingNewsData: payload };

        case actionTypes.SET_NEWS_CATEGORY:
            return { ...state, newsCategoryData: payload };

        case actionTypes.SET_NEWS_BY_CATEGORY:
            return { ...state, newsByCategoryData: payload };

        //! Live
        case actionTypes.SET_LIVE_VIDEO:
            return { ...state, liveVideoData: payload };

        //! Daily Darshan
        case actionTypes.SET_DAILY_DARSHAN:
            return { ...state, dailyDarshanData: payload };

        default:
            return state;
    }
};

export default sancharReducer;